export function Formatofecha(dateInput) {
  if (!dateInput) return ""; // Si es NULL o vacío, devolver un string vacío

  const date = new Date(dateInput);

  if (isNaN(date.getTime())) return ""; // Si la fecha es inválida, retorna vacío

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${year}/${month}/${day}`;
}
